export const P0003600EtatHorsGelEnum = [
  { ref: 0, label: 'P0003600.status.TempHorsGel.off' },
  { ref: 1, label: 'P0003600.status.TempHorsGel.disc' },
  { ref: 2, label: 'P0003600.status.TempHorsGel.cont' },
];
